module.exports = __webpack_public_path__ + "img/typeBlue.c79638e8.png";